import { API } from "../api/API";
import { CurrentUser } from "../../components/login/CurrentUser";
import SocketClient from "../socket/SocketClient";
import { Message } from "../socket/Message";
import IData from "../../interfaces/type1/IData";
import IDataSet from "../../interfaces/type1/IDataSet";
import { ILineChartData } from "../../interfaces/type1/ILineChartData";
import { IPieChartDataSet } from "../../interfaces/type1/IPieChartDataSet";
import { ExtraParamsKeys, IQueryParams } from "../../interfaces/type1/IQueryParams";
import StringUtils from "../../utils/StringUtils";
import DateUtils from "../../utils/DateUtils";
import { ColumnAlingment, ITableDataSet } from "../../interfaces/type1/ITableDataSet";
import Color from "../../utils/Colors";

export interface IDataResult {
    Data: IData[];
    FromDocWin: boolean,
    CreateAt: Date
}

export default class DataFactory {

    static _labelLenght = 20;


    public static async GetRelatorioAsync(params: IQueryParams): Promise<ILineChartData> {
       
        params.GraphicType = 't1';
        let result : ILineChartData;
        switch (params.GraphicId) {
            case '/v1/atos_praticados':
                {
                    result = await DataFactory.GerRelatorioAtosPraticados(params);
                };break;

            case '/v1/atos_gratuitos':
                {
                    result = await DataFactory.GerRelatorioAtosGratuitos(params);
                };break;

            case '/v1/os_hora':
                {
                    result = await DataFactory.GerRelatorioOSsPorHora(params);
                };break;

            case '/v1/atos_por_usuario':
                {
                    result = await DataFactory.GetRelatorioAtosPorUsuarios(params);
                };break;

            case '/v1/desembolsos':
                {
                    result = await DataFactory.GetRelatorioDesembolsos(params);
                };break;

            case '/v1/desempenho_usuario':
                {
                    result = await DataFactory.GetRelatorioDesempenhoPorUsuario(params);
                };break;           

            case '/v1/desempenho_serventia':
                {
                    result = await DataFactory.GetRelatorioDesempenhoServentia(params);
                };break;

            case '/v1/recursos':
                {
                    result = await DataFactory.GetRelatorioRecursos(params);
                };break;

            case '/v1/selos_por_dia':
                {
                    result = await DataFactory.GetRelatorioSelosPorDia(params);
                };break;

                case '/v1/filas_volume':
                {
                    result = await DataFactory.GetRelatorioFilasVolume(params);
                }; break;

                case '/v1/filas_tempo_espera':
                {
                    result = await DataFactory.GetRelatorioFilasTempoEspera(params);
                }; break;

                case '/v1/filas_atendimentos_hora':
                {
                    result = await DataFactory.GetRelatorioFilasAtendimentosPorHora(params);
                }; break;

                case '/v1/filas_cancelamentos':
                {
                    result = await DataFactory.GetRelatorioFilasCancelamentos(params);
                }; break;

                case '/v1/filas_atendimentos_usuario':
                {
                    result = await DataFactory.GetRelatorioFilasAtendimentosPorUsuario(params);
                }; break;

                case '/v1/filas_sla_10_minutos':
                {
                    result = await DataFactory.GetRelatorioFilasSla10Minutos(params);
                }; break;

                case '/v1/filas_aguardando':
                {
                    result = await DataFactory.GetRelatorioFilasAguardando(params);
                }; break;

            default: {
                result = await DataFactory.GetRelatorioAtosPorUsuarios(params);
            }
           
        }

        if(result){
            result!.QueryParams = params;            
        }
       
        
        return result;

    }


    public static async GetDataAsync(params: IQueryParams): Promise<IDataResult> {
       
        let dados = await SocketClient.RequetsGraphicToDocwWindows(new Message('get-graphic', params));  

        if (dados)
            return { CreateAt: new Date(), FromDocWin: true, Data: dados };

        let getDataResponse: Response | undefined;

        try {
            getDataResponse = await API.RequestAsync(`/data/get-data?licenseNumber=${CurrentUser.User?.Licence?.Number}`, CurrentUser.Token?.Token ?? "", 'POST', params);
        } catch { throw new Error("Não foi possivel realizar a requisição HTTP"); }        

        if (!getDataResponse.ok && getDataResponse.status != 404)
            throw new Error(await getDataResponse.text());

        if (!getDataResponse.ok && getDataResponse.status == 404)
            return { CreateAt: new Date(), FromDocWin: false, Data: [] };;

        let data: any = await getDataResponse.json();       

        return { CreateAt: data.CreateAt, FromDocWin: false, Data: JSON.parse(data.JSON) };
    }

    private static ApenasOSQuitadas(params: IQueryParams)
    {
        return  !params.ExtraParams ||  
                !params.ExtraParams.Any(s => s.Key == ExtraParamsKeys.OS_QUITADAS_APENAS) || 
                params.ExtraParams.Any(s => s.Key == ExtraParamsKeys.OS_QUITADAS_APENAS && s.Value === true);
    }


    public static async GerRelatorioAtosPraticados(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);

        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Valores recebidos de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Relatório baseado nos itens executados no período de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}${this.ApenasOSQuitadas(params) ? ",  das ordens de serviços quitadas" : ""}. Valores agrupados por emolumentos.`,
            chartType: 'Bar',
            datasets:
            {
                Data: data,
                Title: "Totais",
            },
            table: {
                Columns: ["Ato", "Quantidade", "Total"],
                Rows: data.Select(v => [v.Group, `${v.Quantity}`, `${StringUtils.MonetaryFormat(v.Total.toFixed(2))}`]), 
                Totals: ["Total", `${data.Sum(s => s.Quantity)}`,`${StringUtils.MonetaryFormat(data.Sum(s => s.Total).toFixed(2))}` ],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]

            },
            pie:
            {
                Data: data.Select(s => s).OrderByDescending(s => s.Total).splice(0, 5),
                ShowLegends: true,
                Title: "5 atos com maiores receitas",
                ShowQuantity: false,
                QuantityLabelFormatter:  q => `${q.Quantity} atos`

            },
            showQuantity: false,
            xFormat: q => StringUtils.FormatToChartLabel(q.Group),
            yFormat: y => StringUtils.MonetaryFormat(y.toFixed(2)),
            tooltipFormat: y => `Total: ${StringUtils.MonetaryFormat(y.Total.toFixed(2))}`,
            quantityFormat: q => `${q.Quantity} atos`
        });
    }



    public static async GerRelatorioAtosGratuitos(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);

        

        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Atos gratuitos de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Relatório baseado nos itens de ordem de serviços executados de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}. Agrupa todas as quantidades por ato.`,
            chartType: 'Bar',
            datasets:
            {
                Data: data,
                Title: "Quantidades",
            },
            table: {
                Columns: ["Ato", "Quantidade"],
                Rows: data.Select(v => [v.Group, `${v.Total}`]),
                Totals: ["Total" , `${data.Sum(s => s.Total)}`],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER]
            },
            pie:
            {
                Data: data.Select(s => s).OrderByDescending(s => s.Total).splice(0, 5),
                ShowLegends: true,
                Title: "5 atos gratuitos mais praticados",
                ShowQuantity: false,
                QuantityLabelFormatter:  q => `${q.Total} atos`

            },
            showQuantity: true,
            xFormat: q => StringUtils.FormatToChartLabel(q.Group),
            yFormat: y => !Number.isInteger(y) ? null : `${y} atos`,
            tooltipFormat: y => `${y.Total} atos`,
            quantityFormat: q => `${q.Total} atos`, 
            
        });
    }


    public static async GerRelatorioOSsPorHora(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);

        

        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `OSs abertas por hora de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Relatório baseado nas ordens de serviço abertas de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}. Itens agrupados por hora do dia.`,
            chartType: 'Bar',
            datasets:
            {
                Data: data.Select(s => {return {...s, Group: `${s.Group}h`}}),
                Title: "Quantidades",
            },
            table: {
                Columns: ["Hora", window.screen.availWidth > 600 ? "Quantidade de Ordens de Serviços" : "Qtd. OSs"],
                Rows: data.Select(v => [`${v.Group}h`, `${v.Total}`]),
                Totals: ["Total" , `${data.Sum(s => s.Total)}`],
                ColumnsAlingments: [ColumnAlingment.START,  ColumnAlingment.CENTER]

            },
            pie:
            {
                Data: data.Select(s => s).OrderByDescending(s => s.Total).splice(0, 5).map(sw => { return { ...sw, Group: `${sw.Group}h` } }),
                ShowLegends: true,
                Title: "5 momentos com mais OSs abertas",
                ShowQuantity: false,
                QuantityLabelFormatter:  q => `${q.Total} OSs`


            },
            showQuantity: true,
            xFormat: q => `${q.Group}`,
            yFormat: y => {

                if(Number.isInteger(y))
                    return `${y}`;
                else
                    return "";
            },
            tooltipFormat: y => `Média de ${y.Total} OSs às ${y.Group}`,
            quantityFormat: q => `${q.Total} OSs`,
            
        });
    }


    public static async GetRelatorioAtosPorUsuarios(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);

        

        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Itens de OS praticados de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Relatório baseado nos itens de ordem de serviços executados de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}${this.ApenasOSQuitadas(params) ? ",  das ordens de serviços quitadas" : ""}. Valores agrupados por usuário.`,
            chartType: 'Bar',
            datasets:
            {
                Data: data,
                Title: "Totais",
            },
            table: {
                Columns: ["Usuário", window.screen.availWidth > 600 ? "Quantidade de Itens" : "Qtd. de Itens", "Total"],
                Rows: data.Select(v => [v.Group, `${v.Quantity}`, StringUtils.MonetaryFormat(v.Total.toFixed(2))]),
                Totals: ["Total" , `${data.Sum(s => s.Quantity)}`, StringUtils.MonetaryFormat(data.Sum(s => s.Total).toFixed(2))],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]
            },
            pie:
            {
                Data: data.Select(s => s).splice(0, 5),
                ShowLegends: true,
                Title: "5 usuários com maiores receitas",
                ShowQuantity: false,
                QuantityLabelFormatter:  y => `${y.Quantity} atos`,
            },
            showQuantity: false,
            xFormat: q => StringUtils.FormatToChartLabel(q.Group),
            yFormat: y => StringUtils.MonetaryFormat(y.toFixed(2)),
            tooltipFormat: y => `Total: ${StringUtils.MonetaryFormat(y.Total.toFixed(2))} em ${y.Quantity} ${y.Quantity > 1 ? 'Itens de OS' : 'Item de OS'}`,
            quantityFormat: q => `Qtd. ${q.Quantity}`
        });
    }

    public static async GetRelatorioDesembolsos(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);

        

        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Desembolsos de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Relatório baseado nos valores de despesas, agrupados por plano de contas do período de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}.`,
            chartType: 'Bar',
            datasets:
            {
                Data: data,
                Title: "Totais",
            },
            table: {
                Columns: ["Ato", "Quantidade", "Total"],
                Rows: data.Select(v => [v.Group, `${v.Quantity}`, StringUtils.MonetaryFormat(v.Total.toFixed(2))]),
                Totals: ["Total" , `${data.Sum(s => s.Quantity)}`, StringUtils.MonetaryFormat(data.Sum(s => s.Total).toFixed(2))],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]
            },
            pie:
            {
                Data: data.Select(s => s).splice(0, 5),
                ShowLegends: true,
                Title: "5 maiores desembolsos",
                ShowQuantity: false,
                QuantityLabelFormatter:  y => StringUtils.MonetaryFormat(y.Total.toFixed(2)),
            },
            showQuantity: true,
            xFormat: q => StringUtils.FormatToChartLabel(q.Group),
            yFormat: y => `R$ ${y.toFixed(2).replace('.', ',')}`,
            tooltipFormat: y => `Total: ${StringUtils.MonetaryFormat(y.Total.toFixed(2))} em ${y.Quantity} lançamento${y.Quantity > 1 ? 's' : ''}`,
            quantityFormat: q => `Qtd. ${q.Quantity}`
        });
    }

    public static async GetRelatorioDesempenhoPorUsuario(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);

        

        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `OSs atendidas por usuários de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Relatório baseado nas OSs que tiveram itens executados pelo usuário de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}${this.ApenasOSQuitadas(params) ? ",  das ordens de serviços quitadas" : ""}. Quantidades e valores agrupados por usuário.`,
            chartType: 'Bar',
            datasets:
            {
                Data: data,
                Title: "Totais",
            },
            table: {
                Columns: ["Usuário", "Quantidade de OSs", "Total"],
                Rows: data.Select(v => [v.Group, `${v.Total}`, `${StringUtils.MonetaryFormat(Number.parseFloat(v.ExtraInfo).toFixed(2))}`]), 
                Totals: ["Total" , `${data.Sum(s => s.Total)}`, StringUtils.MonetaryFormat(data.Sum(s => Number.parseFloat(s.ExtraInfo)).toFixed(2))],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]
            },
            pie:
            {
                Data: data.Select(s => s).splice(0, 5),
                ShowLegends: true,
                Title: "5 usuários que mais atenderam OSs",
                ShowQuantity: false,
                QuantityLabelFormatter:  q => `${q.Total} OSs`
            },
            showQuantity: true,
            xFormat: q => StringUtils.TruncateStringForLabel(q.Group),
            yFormat: y => `${y} OSs`,
            tooltipFormat: y => `Total: ${StringUtils.MonetaryFormat(Number.parseFloat(y.ExtraInfo).toFixed(2))} em ${y.Total} OSs`,
            quantityFormat: q => `Qtd. de OSs ${q.Total}`
        });
    }

   


    public static async GetRelatorioDesempenhoServentia(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);

        

        let data = result.Data;

        for(let r of data.Where(s => s.ExtraInfo == "Recursos"))
            r.ExtraInfo = "Entradas";
        for(let r of data.Where(s => s.ExtraInfo == "Desembolsos"))
            r.ExtraInfo = "Saídas";

        
        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Entradas e saídas utilizadas de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Total de Entradas e Saídas agrupadas por dia do período de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}.`,
            chartType: data.Distinct(s => s.Group).Count() > 2 ? 'Line' : 'Bar' ,
            datasets:
            {
                Data: data,
                Title: "Totais",
                SeriesGroupFunction: () => {

                    return data.GroupBy(q => q.ExtraInfo).OrderBy(s => s.Key).Select(s => {

                        return {Key: s.Key, Data: s.Values, ColorIndex : s.Key == "Entradas" ? Color.GoodColorIndex : Color.BadColorIndex}
                    });
                },
            },
            table: {
                Columns: ["Data", "Entradas", "Saídas"],
                Rows: data.GroupBy(s => s.Group).OrderBy(s => s.Key).Select(v => [
                    DateUtils.CastDateToString(DateUtils.CastStringToDate(v.Key)), 
                    StringUtils.MonetaryFormat(v.Values.Where(s => s.ExtraInfo == "Entradas").Sum(s => s.Total).toString()), 
                    StringUtils.MonetaryFormat(v.Values.Where(s => s.ExtraInfo != "Entradas").Sum(s => s.Total).toString())]),
                    Totals: ["Total" ,                          
                        StringUtils.MonetaryFormat(data.Where(s => s.ExtraInfo == "Entradas").Sum(s => s.Total).toFixed(2)),
                        StringUtils.MonetaryFormat(data.Where(s => s.ExtraInfo != "Entradas").Sum(s => s.Total).toFixed(2)) 
                    ],
                    ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]
                },
            pie:
            {
                Data: data.Where(s => s.ExtraInfo == 'Entradas').OrderByDescending(s => s.Total).Select(s => {

                    return {...s, Group : DateUtils.CastDateToString(DateUtils.CastStringToDate(s.Group))};
                }).splice(0, 5),
                ShowLegends: true,
                Title: "Dias com maiores receitas",
                ShowQuantity: false,
                QuantityLabelFormatter:  q => DateUtils.CastDateToString(DateUtils.CastStringToDate(q.Group)),
            },
            showQuantity: true,
            labelFormat: q => DateUtils.CastDateToString(DateUtils.CastStringToDate(q)),
            yFormat: y => StringUtils.MonetaryFormat(y.toFixed(2)),
            tooltipFormat: y => `${y.ExtraInfo}: ${StringUtils.MonetaryFormat(y.Total.toFixed(2))}`,
            showLegend: true,   
        });
    }


    public static async GetRelatorioSelosPorDia(params: IQueryParams) {


        let result = await DataFactory.GetDataAsync(params);
      
        let data = result.Data;

        data.forEach(d => d.Total = d.Quantity);

        
        for(let r of data.Where(s => s.ExtraInfo == "UTILIZADOS"))
            r.ExtraInfo = "Utilizados";
        for(let r of data.Where(s => s.ExtraInfo == "ENVIADOS"))
            r.ExtraInfo = "Enviados";


        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Selos utilizados/enviados de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Relatório baseado nos selos utilizados/enviados de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}.
            Agrupa os selos por dia`,
            chartType: 'Bar',
            datasets:
            {
                Data: data,
                Title: "Selos",
                SeriesGroupFunction: () => {

                    return data.GroupBy(q => q.ExtraInfo).OrderByDescending(s => s.Key).Select(s => {

                        return {Key: s.Key, Data: s.Values.Select(i => {return {...i, Group: i.Group.split(' ')[0]}})}
                    }).Select(s => {return {...s, Data: s.Data.OrderBy(s => s.Group), ColorIndex : s.Key == "Utilizados" ? Color.BadColorIndex : Color.GoodColorIndex}});
                },
            },
            table: {
                Columns: ["Data", "Utilizados", "Enviados"],
                Rows: data.GroupBy(s => s.Group).OrderBy(s => s.Key).Select(v => [
                    DateUtils.CastDateToString(DateUtils.CastStringToDate(v.Key)), 
                    v.Values.Where(s => s.ExtraInfo == "Utilizados").Sum(s => s.Quantity).toString(), 
                    v.Values.Where(s => s.ExtraInfo != "Utilizados").Sum(s => s.Quantity).toString()]),
                Totals: ["Total" ,                          
                        data.Where(s => s.ExtraInfo == "Utilizados").Sum(s => s.Quantity).toString(),
                        data.Where(s => s.ExtraInfo != "Utilizados").Sum(s => s.Quantity).toString() 
                    ],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]
            },
            pie:
            {
                Data: data.Where(s => s.ExtraInfo == 'Utilizados').Select(s => {
                    return {...s, Group: DateUtils.CastDateToString(DateUtils.CastStringToDate(s.Group))};
                }).splice(0, 5),
                ShowLegends: true,
                Title: "Dias com mais selos utilizados",
                ShowQuantity: false,
                QuantityLabelFormatter:  q => `${q.Quantity} selos`,
            },
            showQuantity: true,
            labelFormat: q =>{return q.split(' ')[0]},
            yFormat: y => {

                
                try{                   
                    if(Math.trunc(y) != y)
                    {
                        if(y > data.Max(s => s.Total))
                            y = Math.trunc(y) + 1;
                        else
                            return '';
                    }                   

                }catch{}

                return `${y} selos`
            },
            tooltipFormat: y => `${y.ExtraInfo}: ${y.Quantity} selos`,
            quantityFormat: y => `${y.Quantity} selos`,
            showLegend: true,   
        });
    }

    public static async GetRelatorioRecursos(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);        

        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Entradas recebidas de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Relatório baseado nos itens executados e lançamentos de receitas de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}${this.ApenasOSQuitadas(params) ? ",  das ordens de serviços quitadas" : ""}. Entradas agrupadas por descrição do item de ordem de serviço.`,
            chartType: 'Bar',
            datasets:
            {
                Data: data.OrderByDescending(s => s.Total).Select(s => s),
                Title: "Totais",
            },
            table: {
                Columns: ["Entradas", window.screen.availWidth > 600 ? "Quantidade de Itens e Lançamentos" : "Itens/Lançamentos", "Total"],
                Rows: data.Select(v => [v.Group, `${v.ExtraInfo}`, StringUtils.MonetaryFormat(v.Total.toFixed(2))]),
                Totals: ["Total" , StringUtils.FormatNumber(data.Sum(s => Number.parseInt(s.ExtraInfo)).toString()), StringUtils.MonetaryFormat(data.Sum(s => s.Total).toFixed(2))], 
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]
            },
            pie:
            {
                Data: data.OrderByDescending(s => s.Total).Select(s => s).Take(5),
                ShowLegends: true,
                Title: "Itens com maiores receitas",
                ShowQuantity: false,
                QuantityLabelFormatter:  q => `${q.Group}. ${q.ExtraInfo}`
            },
            showQuantity: true,
            xFormat: q => StringUtils.FormatToChartLabel(q.Group),
            yFormat: y => `R$ ${y.toFixed(2).replace('.', ',')}`,
            tooltipFormat: y => `Total: ${StringUtils.MonetaryFormat(y.Total.toFixed(2))}`,
            quantityFormat: q => `${q.ExtraInfo}`
        });
    }

    public static async GetRelatorioFilasVolume(params: IQueryParams) {
    let result = await DataFactory.GetDataAsync(params);
    let data = result.Data;

    return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Volume de senhas por fila de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Quantidade de senhas emitidas por fila. Ao clicar, exibe o tempo médio de espera.`,
            chartType: 'Bar',
            datasets: {
                Data: data,
                Title: "Senhas",
            },
            table: {
                Columns: ["Fila", "Senhas", "Espera média"],
                Rows: data.Select(v => [v.Group, `${v.Total}`, `${v.ExtraInfo ?? 0} min`]),
                Totals: ["Total", `${data.Sum(s => s.Total)}`, ""],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]
            },
            pie: {
                Data: data.OrderByDescending(s => s.Total).Take(5),
                ShowLegends: true,
                Title: "5 filas com mais senhas",
                ShowQuantity: false,
                QuantityLabelFormatter: q => `${q.Total} senhas`
            },
            showQuantity: true,
            xFormat: q => StringUtils.FormatToChartLabel(q.Group),
            yFormat: y => Number.isInteger(y) ? `${y}` : "",
            tooltipFormat: y => `${y.Total} senhas. Espera média: ${y.ExtraInfo ?? 0} min`,
            quantityFormat: q => `${q.Total}`
        });
    }

    public static async GetRelatorioFilasTempoEspera(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);
        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Tempo médio de espera por fila de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Tempo médio, em minutos, entre a emissão da senha e a chamada.`,
            chartType: 'Bar',
            datasets: {
                Data: data,
                Title: "Minutos",
            },
            table: {
                Columns: ["Fila", "Espera média","Atendimentos"],
                Rows: data.Select(v => [v.Group, `${v.Total} min`, `${v.ExtraInfo}`]),
                Totals: ["Total", "", `${data.Sum(s => Number.parseInt(`${s.ExtraInfo ?? 0}`))}`],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]
            },
            pie: {
                Data: data.OrderByDescending(s => s.Total).Take(5),
                ShowLegends: true,
                Title: "5 maiores esperas médias",
                ShowQuantity: false,
                QuantityLabelFormatter: q => `${q.Total} min`
            },
            showQuantity: true,
            xFormat: q => StringUtils.FormatToChartLabel(q.Group),
            yFormat: y => `${y} min`,
            tooltipFormat: y => `Espera média: ${y.Total} min. Atendimentos: ${y.ExtraInfo}`,
            quantityFormat: q => `${q.Total} min`
        });
    }

    public static async GetRelatorioFilasAtendimentosPorHora(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);
        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Atendimentos por hora de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Quantidade de atendimentos agrupados por hora. Ao clicar, exibe a espera média.`,
            chartType: 'Bar',
            datasets: {
                Data: data,
                Title: "Atendimentos",
            },
            table: {
                Columns: ["Hora", "Atendimentos", "Espera média"],
                Rows: data.Select(v => [v.Group, `${v.Total}`, `${v.ExtraInfo ?? 0} min`]),
                Totals: ["Total", `${data.Sum(s => s.Total)}`, ""],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]
            },
            pie: {
                Data: data.OrderByDescending(s => s.Total).Take(5),
                ShowLegends: true,
                Title: "5 horários com mais atendimentos",
                ShowQuantity: false,
                QuantityLabelFormatter: q => `${q.Total} atendimentos`
            },
            showQuantity: true,
            xFormat: q => q.Group,
            yFormat: y => Number.isInteger(y) ? `${y}` : "",
            tooltipFormat: y => `${y.Total} atendimentos às ${y.Group}. Espera média: ${y.ExtraInfo ?? 0} min`,
            quantityFormat: q => `${q.Total}`
        });
    }

    public static async GetRelatorioFilasCancelamentos(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);
        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Cancelamentos por fila de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Quantidade de senhas canceladas por fila. Ao clicar, exibe o motivo mais frequente.`,
            chartType: 'Bar',
            datasets: {
                Data: data,
                Title: "Cancelamentos",
            },
            table: {
                Columns: ["Fila", "Cancelamentos", "Motivo mais frequente"],
                Rows: data.Select(v => [v.Group, `${v.Total}`, `${v.ExtraInfo ?? ""}`]),
                Totals: ["Total", `${data.Sum(s => s.Total)}`, ""],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.START]
            },
            pie: {
                Data: data.OrderByDescending(s => s.Total).Take(5),
                ShowLegends: true,
                Title: "5 filas com mais cancelamentos",
                ShowQuantity: false,
                QuantityLabelFormatter: q => `${q.Total} cancelamentos`
            },
            showQuantity: true,
            xFormat: q => StringUtils.FormatToChartLabel(q.Group),
            yFormat: y => Number.isInteger(y) ? `${y}` : "",
            tooltipFormat: y => `${y.Total} cancelamentos. Motivo mais comum: ${y.ExtraInfo ?? "não informado"}`,
            quantityFormat: q => `${q.Total}`
        });
    }

    public static async GetRelatorioFilasAtendimentosPorUsuario(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);
        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Atendimentos por usuário de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Quantidade de atendimentos concluídos por usuário. Ao clicar, exibe a duração média do atendimento.`,
            chartType: 'Bar',
            datasets: {
                Data: data,
                Title: "Atendimentos",
            },
            table: {
                Columns: ["Usuário", "Atendimentos", "Duração média"],
                Rows: data.Select(v => [v.Group, `${v.Total}`, `${v.ExtraInfo ?? 0} min`]),
                Totals: ["Total", `${data.Sum(s => s.Total)}`, ""],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]
            },
            pie: {
                Data: data.OrderByDescending(s => s.Total).Take(5),
                ShowLegends: true,
                Title: "5 usuários com mais atendimentos",
                ShowQuantity: false,
                QuantityLabelFormatter: q => `${q.Total} atendimentos`
            },
            showQuantity: true,
            xFormat: q => StringUtils.FormatToChartLabel(q.Group),
            yFormat: y => Number.isInteger(y) ? `${y}` : "",
            tooltipFormat: y => `${y.Total} atendimentos. Duração média: ${y.ExtraInfo ?? 0} min`,
            quantityFormat: q => `${q.Total}`
        });
    }

    public static async GetRelatorioFilasSla10Minutos(params: IQueryParams) {
        let result = await DataFactory.GetDataAsync(params);
        let data = result.Data;

        return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Atendidos em até 10 minutos por fila de ${DataFactory.CastDateToString(params.Start)} até ${DataFactory.CastDateToString(params.End)}`,
            description: `Percentual de senhas chamadas em até 10 minutos. Ao clicar, exibe a espera média da fila.`,
            chartType: 'Bar',
            datasets: {
                Data: data,
                Title: "Percentual",
            },
            table: {
                Columns: ["Fila", "Até 10 min", "Espera média"],
                Rows: data.Select(v => [v.Group, `${v.Total}%`, `${v.ExtraInfo ?? 0} min`]),
                Totals: ["Total", "", ""],
                ColumnsAlingments: [ColumnAlingment.START, ColumnAlingment.CENTER, ColumnAlingment.CENTER]
            },
            pie: {
                Data: data.OrderByDescending(s => s.Total).Take(5),
                ShowLegends: true,
                Title: "5 melhores filas no SLA",
                ShowQuantity: false,
                QuantityLabelFormatter: q => `${q.Total}%`
            },
            showQuantity: true,
            xFormat: q => StringUtils.FormatToChartLabel(q.Group),
            yFormat: y => `${y}%`,
            tooltipFormat: y => `${y.Total}% atendidos em até 10 minutos. Espera média: ${y.ExtraInfo ?? 0} min`,
            quantityFormat: q => `${q.Total}%`
        });
    }


    public static async GetRelatorioFilasAguardando(params: IQueryParams) {
    let result = await DataFactory.GetDataAsync(params);
    let data = result.Data;

    return DataFactory.CreateLineChartData({
            createAt: result.CreateAt,
            fromDOC: result.FromDocWin,
            title: `Senhas de hoje ainda aguardando atendimento por fila`,
            description: `Quantidade de senhas que ainda não foram chamadas, agrupadas por fila. Ao clicar, é exibido o maior tempo de espera da fila.`,
            chartType: 'Bar',
            datasets: {
                Data: data,
                Title: "Aguardando",
            },
            table: {
                Columns: ["Fila", "Aguardando", "Maior espera"],
                Rows: data.Select(v => [v.Group, `${v.Total}`, `${v.ExtraInfo ?? 0} min`]),
                Totals: ["Total", `${data.Sum(s => s.Total)}`, ""],
                ColumnsAlingments: [
                    ColumnAlingment.START,
                    ColumnAlingment.CENTER,
                    ColumnAlingment.CENTER
                ]
            },
            pie: {
                Data: data.OrderByDescending(s => s.Total).Take(5),
                ShowLegends: true,
                Title: "5 filas com mais senhas aguardando",
                ShowQuantity: false,
                QuantityLabelFormatter: q => `${q.Total} aguardando`
            },
            showQuantity: true,
            xFormat: q => StringUtils.FormatToChartLabel(q.Group),
            yFormat: y => Number.isInteger(y) ? `${y}` : "",
            tooltipFormat: y => `${y.Total} senhas aguardando. Maior espera: ${y.ExtraInfo ?? 0} min`,
            quantityFormat: q => `${q.Total}`
        });
    }

    private static CastDateToString(date: Date) {
        let day = date.getDate().toString().padStart(2, '0');
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    private static CastDateToQueryString(date: Date) {
        let day = date.getDate().toString().padStart(2, '0');
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let year = date.getFullYear();

        return `${year}-${month}-${day}`;
    }

    public static CreateLineChartData(options: {
        title: string,
        description: string,
        fromDOC?: boolean,
        createAt?: Date,
        chartType: 'Line' | 'Bar',
        datasets: IDataSet,
        table?: ITableDataSet,
        pie: IPieChartDataSet,
        showQuantity: boolean,
        quantityFormat?: (item: IData) => string,
        xFormat?: (item: IData) => string,
        yFormat?: (y: number) => string | null,
        tooltipFormat?: (item: IData) => string,
        showLegend?: boolean, 
        labelFormat? : (label: string) => string
    }): ILineChartData {
        return {
            Title: options.title,
            Description: options.description,
            ShowLegend: options.showLegend ?? false,
            ShowTitle: true,
            EnableTooltip: true,
            CreatedAt: options.createAt,
            FromWebSocket: options.fromDOC,
            ChartType: options.chartType,
            DataSets: options.datasets,
            PieChartDataSet: options.pie,
            TableDataSet: options.table,
            ShowQuantity: options.showQuantity,
            QuantityLabelFormatter: options.quantityFormat,
            XTickFormatter: options.xFormat,
            YTickFormatter: options.yFormat,
            ToolTipFormatter: options.tooltipFormat, 
            LabelFormat: options.labelFormat

        }
    }
}